// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  background: no-repeat center center rgba(255, 255, 255, 0);
  width: 100%;
  height: 100%;
  background-size: contain;
}
:host::ng-deep .ov-control-panel {
  display: none;
}
:host::ng-deep .ovvioshint {
  display: none;
}
:host::ng-deep .ovviosinfo {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/app/content/modules/page/components/product/components/product-image/orbitvu-360/orbitvu-360.component.scss"],"names":[],"mappings":"AAAA;EACE,0DAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;AACF;AAGI;EACE,aAAA;AADN;AAII;EACE,aAAA;AAFN;AAKI;EACE,aAAA;AAHN","sourcesContent":[":host {\n  background: no-repeat center center rgba(255, 255, 255, 0);\n  width: 100%;\n  height: 100%;\n  background-size: contain;\n\n  &::ng-deep {\n\n    .ov-control-panel {\n      display: none;\n    }\n\n    .ovvioshint {\n      display: none;\n    }\n\n    .ovviosinfo {\n      display: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
